import { render, staticRenderFns } from "./BubbleChart.vue?vue&type=template&id=85d9e8aa&scoped=true"
import script from "./BubbleChart.vue?vue&type=script&lang=js"
export * from "./BubbleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d9e8aa",
  null
  
)

export default component.exports